import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Spin, Result } from 'antd';
import AllBrandsMetrics from '../AllBrandsMetrics';
import SingleBrandMetrics from './SingleBrandMetrics';
import SingleBrandHourlyReport from './SingleBrandHourlyReport';
import api from '../../services/api';

const EmbedPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [tokenData, setTokenData] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setError('Token bulunamadı');
      setLoading(false);
      return;
    }

    // Token'ı API isteklerinde kullanmak için localStorage'a kaydet
    localStorage.setItem('embedToken', token);
    
    // Token'ı doğrula
    const validateToken = async () => {
      try {
        // API instance'ını token ile yapılandır
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Token doğrulama isteği yap
        const response = await api.get('/embed/validate');
        
        // Token verilerini al
        setTokenData(response.data);
        setIsValid(true);
      } catch (error) {
        console.error('Token doğrulama hatası:', error.response || error.message);
        setError(error.response?.data?.error || 'Token geçersiz');
      } finally {
        setLoading(false);
      }
    };

    validateToken();

    // Cleanup
    return () => {
      localStorage.removeItem('embedToken');
      delete api.defaults.headers.common['Authorization'];
    };
  }, [searchParams]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !isValid) {
    return (
      <Result
        status="error"
        title="Erişim Hatası"
        subTitle={error || 'Sayfaya erişim yetkiniz yok.'}
      />
    );
  }

  // URL parametresinden rapor tipini al
  const reportType = searchParams.get('type');

  return (
    <div style={{ 
      padding: '0', 
      margin: '0',
      minHeight: '100vh',
      background: '#fff'
    }}>
      {tokenData?.singleBrand ? (
        // Tek marka gösterimi - rapor tipine göre
        reportType === 'hourly' ? (
          <SingleBrandHourlyReport 
            brandId={tokenData.brandIds[0]} 
            brandName={tokenData.brandName} 
          />
        ) : (
          <SingleBrandMetrics 
            brandId={tokenData.brandIds[0]} 
            brandName={tokenData.brandName} 
          />
        )
      ) : (
        // Çoklu marka gösterimi (tüm markalar ya da seçilen markalar)
        <AllBrandsMetrics 
          isEmbedded={true} 
          tokenData={tokenData}
        />
      )}
    </div>
  );
};

export default EmbedPage; 